import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb-common/interfaces/grid-layout.service";
import { DeleteCellComponent } from "@irb-common/components/grid/renderers/delete.cell.component";
import { DeleteHeaderComponent } from "@irb-common/components/grid/renderers/delete.header.component";
import { UtilityService } from "@irb-common/services/utility.service";
import { ComCashNeedsComponent } from "./com-cash-needs.component";
import {DecimalPipe, DatePipe, formatDate} from "@angular/common";


@Injectable({
    providedIn: "root"
})
export class ComCashNeedsGridLayoutService implements GridLayoutService<ComCashNeedsComponent> {
    constructor(private util: UtilityService, private datePipe: DatePipe, private decimalPipe: DecimalPipe) {        
    }

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent
        };
    }

    mapActiveText(params : any) {
        if(params.data.isActive != null) {
            if(params.data.isActive) {
                return "Active";
            } else {
                let d = new Date();
                d.setHours(0,0,0);
                let s = new Date(params.data.startDate);
                if(s.getTime() < d.getTime()) {
                    return "Expired";
                }
            }
        }
        
        return "";
    }

    cellStyleDollar(params: any) {
        if (params.value && (params.value.includes("-"))) {
            //mark police cells as red
            return {color: '#D30014', 'text-align': 'right'};
        } else {
            return {'text-align': 'right'};
        }
    }
     getPinnedBottomRowData(parent: ComCashNeedsComponent) {
        if (!parent.ENABLE_SETASIDE_CASH) {
            return [];
        }
        return [{
            startDate: '',
            endDate: '',
            value: parent.activeAmount || '',
            isActive: '',
            notes: ''
        }];
    }

    getColumnDefs(parent: ComCashNeedsComponent) {
        return [{
            headerName: "Delete All",
            headerComponent: "DeleteHeaderComponent",
            headerComponentParams: { 
                message: "Remove all Entries?", 
               // note: "Settings (such as maintained cash) will be deleted.",
                proceed: parent.deleteAll.bind(parent),
                cancel: parent.cancelDelete.bind(parent)
            },
            cellRenderer : "DeleteCellComponent",
            cellRendererParams: { 
                message: "Remove this Entry?",
               // note: "Settings (such as maintained cash) will be deleted.",
                proceed: parent.delete.bind(parent),
                cancel: parent.cancelDelete.bind(parent)
            },
            cellClass: '',
            cellClassRules: {
                'disabled-cell': (params: any) => !params.node.rowPinned && !params.data?.isActive && this.mapActiveText(params) == "Expired",
                'footer': (params: any) => { return params.node.rowPinned }
            },
            resizable: false,
            minWidth: 25,
            maxWidth: 25,
            width: 25,
            cellRendererSelector: (params: any) => {
                if (params.node.rowPinned) {
                    return { component: null };
                }
                return { component: 'DeleteCellComponent' };
            }
        },
        
                {
                    headerName: "Start Date",
                    field: "startDate",
                    width: 100,
                    cellRenderer: (params: any) => {
                        if (params.node.rowPinned && parent.ENABLE_SETASIDE_CASH) {
                            return '<strong>Total</strong>';
                        }
                        return params.value ? this.util.formatEasternDate(params.value, '/') : '';
                    },
                    sort:"asc",
                    comparator: this.sortDate.bind(this),
                    cellClass: '',
                    cellClassRules: {
                        'disabled-cell': (params: any) => !params.node.rowPinned && !params.data?.isActive && this.mapActiveText(params) == "Expired",
                        'footer': (params: any) => { return params.node.rowPinned }
                    }
                },
                ...(parent.ENABLE_SETASIDE_CASH ? [{
                    headerName: "End Date",
                    field: "endDate",
                    width: 100,
                    valueFormatter: (params: any) => {
                        if (params.node.rowPinned) {
                            return params.value;
                        }
                        return params.value ? this.util.formatEasternDate(params.value, '/') : '';
                    },
                    comparator: this.sortDate.bind(this),
                    cellClass: '',
                    cellClassRules: {
                        'disabled-cell': (params: any) => !params.node.rowPinned && !params.data?.isActive && this.mapActiveText(params) == "Expired",
                        'footer': (params: any) => { return params.node.rowPinned }
                    }
                }] : []),

                {
                    headerName: "Amount ($ or %)",
                    field: "value",
                    width: 100,
                    comparator: this.sortAmount.bind(this),
                    valueFormatter: this.formatAmountDisplay.bind(this),
                    cellClass: '',
                    cellClassRules: {
                        'disabled-cell': (params: any) => !params.node.rowPinned && !params.data?.isActive && this.mapActiveText(params) == "Expired",
                        'footer': (params: any) => { return params.node.rowPinned }
                    },
                    cellStyle: this.cellStyleDollar
                },
                {
                    headerName: "Status",
                    field: "isActive",
                    width: 100,
                    valueGetter: this.mapActiveText,
                    cellClass: '',
                    cellClassRules: {
                        'disabled-cell': (params: any) => !params.node.rowPinned && !params.data?.isActive && this.mapActiveText(params) == "Expired",
                        'footer': (params: any) => { return params.node.rowPinned }
                    }
                },
                {
                    headerName: "Note",
                    field: "notes",
                    flex: 1,
                    cellClass: '',
                    cellClassRules: {
                        'disabled-cell': (params: any) => !params.node.rowPinned && !params.data?.isActive && this.mapActiveText(params) == "Expired",
                        'footer': (params: any) => { return params.node.rowPinned }
                    },
                    cellRenderer: 'cellRendererFormatter'
                }
               
        ];
    }

    sortAmount(a: any, b: any) {
        if (a === null || typeof a === "undefined") {
            return -1;
        } else if (b === null || typeof b === "undefined") {
            return 1;
        }
        a = parseFloat(a.replace('%','').replace('$',''));
        b = parseFloat(b.replace('%','').replace('$',''));
        if (a === null || typeof a === "undefined" || isNaN(a)) {
            return -1;
        } else if (b === null || typeof b === "undefined" || isNaN(b)) {
            return 1;
        } else {
            return a < b ? -1 : a > b ? 1 : 0;
        }
    }

    sortDate(a: any, b: any) {
        a = new Date(a).getTime();
        b = new Date(b).getTime();
        if (a === null || typeof a === "undefined" || isNaN(a)) {
            return -1;
        } else if (b === null || typeof b === "undefined" || isNaN(b)) {
            return 1;
        } else {
            return a < b ? -1 : a > b ? 1 : 0;
        }
    }
    formatAmountDisplay(params: any) {
        const value = params?.value;
        if (value === null || typeof value === "undefined") {
            return value;
        }

        const stringValue = String(value).trim();
        if (stringValue.includes('%')) {
            return stringValue;
        }

        if (!stringValue.includes('$')) {
            return stringValue;
        }

        const normalized = stringValue
            .replace(/\$/g, "")
            .replace(/,/g, "")
            .replace(/[()]/g, "")
            .trim();

        const parsed = parseFloat(normalized);
        if (isNaN(parsed)) {
            return stringValue;
        }

        const isNegative = stringValue.includes('-') || (stringValue.includes('(') && stringValue.includes(')'));
        const numericValue = isNegative ? -Math.abs(parsed) : parsed;

        return numericValue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

}
